import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { LinhaTelefonica } from './linha-telefonica.model';
import { NTECH_API } from '../app.api';
import { OperadoraService } from '../operadora/operadora.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-linha-telefonica',
  templateUrl: './linha-telefonica.component.html',
  styleUrls: ['./linha-telefonica.component.css']
})
export class LinhaTelefonicaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  loadingVisible = false;
  listaLinhaTelefonica: CustomStore;
  listaOperadora = null;
  listaForm = {Id: 'listaOperadora', status: false};
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;


  colunasGridLinhaTelefonica = [];

  editOptionsGridLinhaTelefonica = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Linha Telefônica',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private operadoraService: OperadoraService
  ) {
    this.loadingVisible = true;
    // carrega a lista de Operadoras
    this.operadoraService.getOperadoras()
      .subscribe(operadoras => {
        this.listaOperadora = operadoras;
        this.verificarListasCarregadas('listaOperadora');
      },
      error => {
        this.verificarListasCarregadas('listaOperadora');
      }
    );

    this.listaLinhaTelefonica = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/linha-telefonica/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/linha-telefonica/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/linha-telefonica/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/linha-telefonica/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      this.listaForm.status = true;
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if (this.listaForm.status === true) {

      this.colunasGridLinhaTelefonica = [
        {
          dataField: 'Id',
          dataType: 'string',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'Numero',
          dataType: 'string',
          caption: 'Número',
          validationRules: [{
            type: 'required',
            message: 'Número é obrigatório.'
          }]
        },
        {
          dataField: 'IdOperadora',
          caption: 'Operadora',
          lookup: {
              dataSource: this.listaOperadora,
              displayExpr: 'DescricaoOperadora',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Operadora é obrigatório.'
          }]
        }
      ];
      this.loadingVisible = false;
      return true;
    } else {
      return false;
    }
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/app/linha-telefonica/linha-telefonica.component.ts